/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CreateProjectResponseContent
 */
export interface CreateProjectResponseContent {
    /**
     * 
     * @type {string}
     * @memberof CreateProjectResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the CreateProjectResponseContent interface.
 */
export function instanceOfCreateProjectResponseContent(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function CreateProjectResponseContentFromJSON(json: any): CreateProjectResponseContent {
    return CreateProjectResponseContentFromJSONTyped(json, false);
}

export function CreateProjectResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProjectResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function CreateProjectResponseContentToJSON(value?: CreateProjectResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

